
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import { environment } from '@environments/environment';

const NO_LOADER_URL_PARTS = [
  'v1/order/get/eta',
  `${environment.logoutUrl}`
];

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  const hasNoLoaderHeader = req.headers.get('x-no-loader') === 'true';
  const matchesNoLoaderUrl = NO_LOADER_URL_PARTS.some((p) => req.url.includes(p));
  const skip = hasNoLoaderHeader || matchesNoLoaderUrl;

  if (!skip) loading.start();

  return next(req).pipe(finalize(() => {
    if (!skip) loading.stop();
  }));
};
